import { useQuery } from '@apollo/client/react'
import { GET_ALL_USER_BLACKLIST } from '@graphql'
import { getToken, getUserData } from '@utils'
import { IGetUserBlackList } from '../types'

export const useBlackList = () => {
  const { data: allUsers } = useQuery<IGetUserBlackList>(GET_ALL_USER_BLACKLIST)
  const userList = allUsers?.getUserFromBlacklist

  const userData = getUserData(getToken())

  const blacklist =
    userList?.map((elem) => ({
      email: elem?.email,
      phone: elem.phone,
    })) || []

  const isDisabledUser = blacklist?.find((elem) => elem.email === userData?.email)

  const blacklistPhone = (phone) => blacklist.some((elem) => elem.phone === phone)

  return {
    isDisabledUser,
    blacklistPhone,
    userData,
  }
}
